import { Component } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { ContentcmsService } from 'projects/authentication/_services/contentcms.service';
import { GlobalService } from './_core/global.service';
import { BehaviorService } from './_core/_services/behavior.service';
import { DoOptinService } from './_core/_services/do-optin.service';
import { EventsService } from './_core/_services/events.service';
import { LangService } from './_core/_services/lang.service';
import { ProductConfigsService } from './_core/_services/product-configs.service';
import { ThemeService } from './_core/_services/theme.service';
import { Title } from '@angular/platform-browser';

declare var firebase: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public showSideNav$: boolean;
  public popUp$: boolean;

  public propsLoaded: boolean = false;
  public loadError: boolean = false;

  public lottieOptions: AnimationOptions = { path: 'https://webportals.cachefly.net/global/upar/assets/lotties/connection-lost.json' };
  public lottieStyles: Partial<CSSStyleDeclaration> = { margin: '0 auto' };

  constructor(
    private lang: LangService,
    private router: Router,
    private global: GlobalService,
    private beh: BehaviorService,
    private event: EventsService,
    private conf: ProductConfigsService,
    private optin: DoOptinService,
    private contSvc: ContentcmsService,
    private themeSvc: ThemeService,
    private title: Title
  ) {
    this.themeSvc.checkTheme();
    window.addEventListener('beforeinstallprompt', (event) => { event.preventDefault() });

    // if (location.protocol == 'http:' && !~['localhost', 'qua.upar.gg', 'staging.upar.gg'].indexOf(location.hostname)) { location.protocol = 'https:' }

    this.inWebView();
    this.getTid();

    this.conf.portalConf().subscribe(props => {
      if (props) {
        console.debug(this.global.propConfs$);
        !!this.global.propConfs$?.portalName && this.title.setTitle(this.global.propConfs$.portalName);
        !!this.global.propConfs$?.analyticsId && this.injectAnalytics(this.global.propConfs$.analyticsId);
        !!this.global.event.firebase && !!this.global.propConfs$?.firebaseConfigs && this.injectFirebase();

        this.contSvc.getContent('homepage_settings').subscribe(setts => {
          this.beh.initialCmsSetts.next(this.global.entitysToPlain(setts?.list || [])[0] || {});
        }, () => { this.beh.initialCmsSetts.next({}) });

        this.contSvc.getContent('lang').subscribe(contents => {
          if (!!contents) {
            let langs = [];
            for (let l of this.global.entitysToPlain(contents?.list || [])) { !!l?.iso_code && langs.push(l.iso_code.replace('_', '-')) }
            this.beh.portalLangs.next(!!langs?.length ? langs : ['en']);
          }
          this.initialLoads();
        }, () => { this.initialLoads() });
      } else { this.loadError = true }
    }, () => { this.loadError = true });
  }

  private initialLoads() {
    this.lang.lang.subscribe(l => { document.body.setAttribute('dir', l == 'ar' ? 'rtl' : 'ltr') });
    this.global.initPush();
    this.lang.setLang();
    this.event.eventStart({ eventType: 'APP_INIT', eventCategory: 'INIT' });

    this.optin.init().subscribe(succ => { this.propsLoaded = true }, () => { this.loadError = true });

    this.beh.showSideNav.subscribe(val => {
      const set = setTimeout(() => { this.showSideNav$ = val; this.global.bodyScroll(this.showSideNav$) }, 300);
      if (val) { this.showSideNav$ = val; this.global.bodyScroll(this.showSideNav$); clearTimeout(set) } else { set }
    });

    this.beh.popup.subscribe(val => {
      const set = setTimeout(() => { this.popUp$ = !!val; this.global.bodyScroll(this.popUp$) }, 300);
      if (!!val) { this.popUp$ = !!val; this.global.bodyScroll(this.popUp$); clearTimeout(set) } else { set }
    });

    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        this.beh.showSideNav.next(false);
        // this.beh.popup.next(null);
      }
    });

    /* setTimeout(() => {
      // this.beh.popup.next({ pop: 'custom', extraData: { subtitle: 'payment.msisdnSuspended', sub_button_action_type: 'ACTION', sub_button_action: '', sub_button_text: 'popup.close' } });
      // this.beh.popup.next({ pop: 'custom', extraData: { subtitle: 'payment.ATT_ACCOUNT_VALIDATION_FAILED', sub_button_action_type: 'ACTION', sub_button_action: '', sub_button_text: 'popup.close' } });
    }, 1000); */
  }

  private inWebView() {
    let params = new URLSearchParams(location.search);
    params.has('source') && (localStorage.s = params.get('source'));

    !!location.search && (sessionStorage.qP = location.search);
  }

  private injectAnalytics(id) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${id}');`;
    let includeScript = document.createElement('script');
    includeScript.async = true;
    includeScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(includeScript);
    document.head.appendChild(script);
  }

  private injectFirebase() {
    firebase.initializeApp({ ...this.global.firebaseConf, ...JSON.parse(this.global.propConfs$?.firebaseConfigs || '{}') });
    firebase.analytics();
  }

  private getTid() {
    let userSession = JSON.parse(sessionStorage.u || '{}');
    if (!!this.global.getQueryParams().tid) {
      userSession.tid = this.global.getQueryParams().tid;
      sessionStorage.u = JSON.stringify(userSession);
    }
  }
}
